import styled from 'styled-components/macro';

const SimpleButton = styled.button`
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
  color: #fff;
  transition: opacity 0.25s ease-out;

  &:disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
`;

export default SimpleButton;
